export default "__VITE_ASSET__Vt5y8G7P__"